import React, { useState, useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { useNavigate, useLocation } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import moment from "moment";
import Select from "react-select";
import PubSub from "pubsub-js";
import Main from "../layout/Main";
import Helmet from "react-helmet";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";

const SupplierEdit = (props) => {
  let fnYear;
  const location = useLocation();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});
  const [supplierOption, setOptionSupplier] = useState({});
  const [selectedSupplier, setSelectedSupplier] = useState({});
  const [itemOption, setOptionItem] = useState({});
  const [selectedItem, setSelectedItem] = useState({});
  const [branchOption, setOptionBranch] = useState({});
  const [selectedbranch, setSelectedBranch] = useState({});
  const [clientOption, setOptionClient] = useState({});
  const [selectedClient, setSelectedClient] = useState({});
  const [vechicleOption, setOptionVechicle] = useState({});
  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [selectedCity, setSelectedCity] = useState({});
  const [cityOption, setOptionCity] = useState({});
  const [selectedToCity, setSelectedToCity] = useState({});
  const [challanData, setChallanData] = useState(
    location.state
      ? location.state
      : { challan_date: moment().format("YYYY-MM-DD"),tds: 0,
        deduction: 0,
        paid_amount: 0 }
  );
  const [challanDieselData, setChallanDieselData] = useState(
    location.state
      ? location.state
      : { challan_advance_date: moment().format("YYYY-MM-DD") }
  );
  const [challanAdvanceData, setChallanAdvanceData] = useState(
    location.state
      ? location.state
      : { challan_date: moment().format("YYYY-MM-DD") }
  );
  const [selectedAdvanceBranch, setSelectedAdvanceBranch] = useState({});
  const [branchAdvanceOption, setOptionAdvanceBranch] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      const fnYear = await trasportApi.fetchAllActiveFinancialYears();
      const itemRec = await trasportApi.fetchAllItem();
      const branchRec = await trasportApi.fetchClientInvoiceByPendingStatus();
      const clientRec = await trasportApi.fetchAllClient();
      // const vechicleRec = await trasportApi.fetchAllVehicles();
      const cityRec = await trasportApi.fetchAllCity();
      const supplierRec = await trasportApi.fetchAllSupplier();

      if (fnYear && fnYear.length) {
        let ar = [];
        fnYear.forEach((item) => {
          ar.push({ value: item.id, label: item.name });
        });

        const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
        const currentYear = new Date().getFullYear();
        let defaultOption;

        if (currentMonth >= 3) {
          // March is the 3rd month
          defaultOption = ar.find(
            (option) => option.label === `${currentYear}-${currentYear + 1}`
          );
        } else {
          defaultOption = ar.find(
            (option) => option.label === `${currentYear - 1}-${currentYear}`
          );
        }

        if (defaultOption) {
          setSelectedFinancialYear(defaultOption);
          setChallanData({
            ...challanData,
            financial_year_id: defaultOption.value,
          });
        } else if (location?.state) {
          const acc = ar.find(
            (acc) => acc.value === location.state.financial_year_id
          );
          setSelectedFinancialYear(acc);
        }
        setOptionFinancialYear(ar);
      } else {
        setOptionFinancialYear([]);
      }

      //Invoice Api Data.
      if (branchRec && branchRec.length) {
        let ar = [];
        branchRec.forEach((item) => {
          ar.push({ value: item.id, label: item.invoice_number });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.invoice_id);
          setSelectedBranch(acc);
          // setSelectedAdvanceBranch(acc2);
        }
        setOptionBranch(ar);
        setOptionAdvanceBranch(ar);
      } else {
        setOptionBranch([]);
      }
      //Client Api Data.
      if (clientRec && clientRec.length) {
        let ar = [];
        clientRec.forEach((item) => {
          ar.push({ value: item.id, label: item.client_name });
        });

        if (location?.state) {
          const acc = ar.find((acc) => acc.value === location.state.client_id);
          setSelectedClient(acc);
        }
        setOptionClient(ar);
      } else {
        setOptionClient([]);
      }
    };
    
    fetchData();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const updatedChallanData = { ...challanData, [name]: value };
  
    // Validate future date for "challan_date"
    if (name === "date_of_payment_recd") {
      const selectedDate = new Date(value);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // Reset today's time for comparison
  
      // Uncomment if future date validation is needed
      // if (selectedDate > today) {
      //   alert("Future Challan Date are not allowed.");
      //   return;
      // }
    }
  
    // Parse values for calculations
    let invoice_amount = parseFloat(selectedbranch.invoice_amount || 0);
    let deduction = parseFloat(updatedChallanData.deduction || 0); // Deduction value
    let tds = parseFloat(updatedChallanData.tds || 0); // TDS value
  
    // Check if TDS or Deduction is changed and calculate accordingly
    if (name === 'invoice_amount' || name === 'deduction' || name === 'tds') {
      if (tds > 0) {
        // If TDS is entered, calculate deduction based on TDS
        const tdsAmount = (invoice_amount * tds) / 100; // Calculate TDS amount based on percentage
        updatedChallanData.paid_amount = (invoice_amount - tdsAmount - deduction).toFixed(2); // Subtract both TDS and manual deduction from invoice amount to get paid amount  
        updatedChallanData.outstanding = (invoice_amount - tdsAmount - deduction).toFixed(2); // Subtract both TDS and manual deduction from invoice amount to get paid amount  
      } else if (deduction > 0) {
        // If deduction is entered without TDS, subtract it from the invoice amount
        updatedChallanData.paid_amount = (invoice_amount - deduction).toFixed(2); // Subtract manual deduction from invoice amount
        updatedChallanData.outstanding = (invoice_amount - deduction).toFixed(2); // Subtract manual deduction from invoice amount
      } else {
        // If no TDS or Deduction, paid_amount is same as invoice_amount
        updatedChallanData.paid_amount = invoice_amount.toFixed(2);
        updatedChallanData.outstanding = invoice_amount.toFixed(2);
      }
    }
  
    setChallanData(updatedChallanData);
  };
  


  const checkRequiredFields = () => {
    if (
      challanData.client_name &&
      challanData.email &&
      challanData.phone &&
      challanData.city &&
      challanData.address &&
      challanData.financial_year_id &&
      challanData.district &&
      challanData.state &&
      challanData.country &&
      challanData.pincode &&
      challanData.pan_number &&
      challanData.gst_no &&
      challanData.tin_no &&
      challanData.ecc_no
    ) {
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};

    if (challanData.id) {
      challanData.challan_invoice_status = 'Pending';
      challanData.challan_id = 
      result2 = await trasportApi.saveClientInvoicePayment(challanData);
      if (result2.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Updated successfully",
        });
        navigate(`/clientinvoicepayments/${challanData.id}`, { state: challanData });
      }
    } else {
      
      challanData.challan_invoice_status = 'Pending';
      result2 = await trasportApi.createClientInvoicePayment(challanData);
      if (result2?.id) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/clientinvoicepayments/${result2.id}`, { state: result2 });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Record ERROR",
          message: result2.errors[0].msg,
        });
      }
    }
  };

  const handleCancel = () => {
    if (location.state?.id) {
      navigate("/clientinvoicepayments/" + challanData.id, { state: challanData });
    } else {
      navigate("/clientinvoicepayments/");
    }
  };

  //FinancialYear
  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setChallanData({ ...challanData, financial_year_id: e.value });
  };

  //Item
  const handleItem = (e) => {
    setSelectedItem(e);
    challanData.item_deduction_rate = itemOption[0].price_deduction;

    setChallanData({ ...challanData, item_id: e.value });
  };

  //Client
  const handleClient = async (e) => {
    setSelectedClient(e);
    setChallanData({ ...challanData, client_id: e.value });
    const invoiceData = await trasportApi.fetchClientInvoiceStatusById(
      e?.value
    );
    if (invoiceData) {
      let ar = [];
      invoiceData.forEach((item) => {
        ar.push({
          value: item.id,
          label: item.invoice_number,
          invoice_amount: item.total_invoice_amount,
        });
      });

      if (location?.state) {
        const acc = ar.find((acc) => acc.value === location.state.invoice_id);
        setSelectedBranch(acc);
        // setSelectedAdvanceBranch(acc2);
      }
      setOptionBranch(ar);
      setOptionAdvanceBranch(ar);
    } else {
      setOptionBranch([]);
    }
  };

  //Branch
  const handleBranch = (e) => {
    setSelectedBranch(e);
    setChallanData({ ...challanData, invoice_id: e.value });
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.ChallanEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header align-items-center">
                <Col lg={3}>Edit Challan Master</Col>
                <Col lg={9} className="d-flex justify-content-end">
                  <Button className="btn-sm mx-2" onClick={handleSubmit}>
                    Save
                  </Button>
                  <Button
                    className="btn-sm"
                    variant="danger"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
              <Row>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Financial Year
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Financial Year"
                      value={selectedFinancialYear}
                      onChange={handlefinancialYear}
                      options={financialYearOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Financial Year.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Date Of Payment
                    </Form.Label>
                    <Form.Control
                      type="date"
                      name="date_of_payment_recd"
                      placeholder="Enter Your Payment Date"
                      value={
                        challanData
                          ? moment(challanData.date_of_payment_recd).format(
                              "YYYY-MM-DD"
                            )
                          : ""
                      }
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Client /Party Name
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Party Name"
                      value={selectedClient}
                      onChange={handleClient}
                      options={clientOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Client Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label className="form-view-label">
                      Invoice No
                    </Form.Label>
                    <Select
                      required
                      className="custom-select username"
                      placeholder="Select Branch Name"
                      value={selectedbranch}
                      onChange={handleBranch}
                      options={branchOption}
                    ></Select>
                    <Form.Control.Feedback type="invalid">
                      Please Select Branch Name.
                    </Form.Control.Feedback>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Invoice Amount
                    </Form.Label>
                    ₹{/* (Rs) */}
                    <Form.Control
                      required
                      disabled
                      style={{ marginLeft: "19px", marginTop: "-20px" }}
                      type="number"
                      name="invoice_amount"
                      placeholder="Total Invoice Amount"
                      value={selectedbranch.invoice_amount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      TDS
                    </Form.Label>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="number"
                        name="tds"
                        placeholder="Total TDS %"
                        value={challanData.tds}
                        onChange={handleChange}
                      />
                      <span className="ms-2">%</span>
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Deduction(if any)
                    </Form.Label>
                    <div className="d-flex align-items-center">
                      <Form.Control
                        type="number"
                        name="deduction"
                        placeholder="Enter Deduction Amount"
                        value={challanData.deduction}
                        onChange={handleChange}
                      />
                      <span className="ms-2">%</span>
                    </div>
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Payment Recd
                    </Form.Label>
                    ₹{/* (Rs) */}
                    <Form.Control
                      style={{ marginLeft: "19px", marginTop: "-23px" }}
                      type="number"
                      name="paid_amount"
                      placeholder="Paid Amount"
                      value={challanData.paid_amount}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Outstanding Amount
                    </Form.Label>
                    ₹{/* (Rs) */}
                    <Form.Control
                      style={{ marginLeft: "19px", marginTop: "-23px" }}
                      disabled
                      type="number"
                      name="outstanding"
                      placeholder="Outstanding Amount"
                      value={challanData.outstanding}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col lg={4} style={{marginLeft : ""}}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="paymentType"
                    >
                      Payment Type
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="paymentType"
                      name="payment_mode"
                      className="form-view-label"
                      value={challanData.payment_mode || ""}
                      onChange={handleChange}
                    >
                      <option value="">--Select--</option>
                      <option value="CASH">CASH</option>
                      <option value="DD/Cheque No">DD/Cheque No</option>
                      <option value="Neft Details">Neft Details</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                {(challanData.payment_mode === "DD/Cheque No" ||
                  challanData.payment_mode === "Neft Details") && (
                  <>
                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="bankName"
                        >
                          Bank Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="bankName"
                          name="bank_name"
                          placeholder="Enter Bank Name"
                          value={challanData.bank_name || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={4}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="chequeNumber"
                        >
                          Cheque No. / DD No. / NEFT Trans No.
                        </Form.Label>
                        <Form.Control
                          type="text"
                          id="chequeNumber"
                          name="cheque_no"
                          placeholder="Enter Cheque No. / DD No. / NEFT Trans No"
                          value={challanData.cheque_no || ""}
                          onChange={handleChange}
                        />
                      </Form.Group>
                    </Col>
                  </>
                )}
                <Col lg={4}>
                  <Form.Group className="mx-3">
                    <Form.Label
                      className="form-view-label"
                      htmlFor="formBasicAdmissiondate"
                    >
                      Remark
                    </Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      name="remark"
                      placeholder="Enter a Remark"
                      value={challanData.remark}
                      onChange={handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};
export default SupplierEdit;
